/*
 *
 * UserList constants
 *
 */

export const FETCH_USERS = 'app/UserList/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'app/UserList/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'app/UserList/FETCH_USERS_FAILURE';

export const FETCH_RESEARCHERS_REQUEST =
  'app/UserList/FETCH_RESEARCHERS_REQUEST';
export const FETCH_RESEARCHERS_SUCCESS =
  'app/UserList/FETCH_RESEARCHERS_SUCCESS';
export const FETCH_RESEARCHERS_FAILURE =
  'app/UserList/FETCH_RESEARCHERS_FAILURE';

export const FETCH_USERS_SELECTOR = 'app/UserList/FETCH_USERS_SELECTOR';
export const FETCH_USERS_SELECTOR_SUCCESS =
  'app/UserList/FETCH_USERS_SELECTOR_SUCCESS';
export const FETCH_USERS_SELECTOR_FAILURE =
  'app/UserList/FETCH_USERS_SELECTOR_FAILURE';

export const CHANGE_ACTIVATE_STATUS_REQUEST =
  'app/UserList/CHANGE_ACTIVATE_STATUS_REQUEST';
export const CHANGE_ACTIVATE_STATUS_SUCCESS =
  'app/UserList/CHANGE_ACTIVATE_STATUS_SUCCESS';
export const CHANGE_ACTIVATE_STATUS_FAILURE = 'app/UserList/LIST_EDIT_FAILURE';
export const PER_PAGE = 10;

export const ADD_USER_TO_LIST = 'app/UserList/ADD_USER_TO_LIST';

export const DELETE_USER_FROM_TEAM_REQUEST =
  'app/UserList/DELETE_USER_FROM_TEAM_REQUEST';
export const DELETE_USER_FROM_TEAM_SUCCESS =
  'app/UserList/DELETE_USER_FROM_TEAM_SUCCESS';
export const DELETE_USER_FROM_TEAM_FAILURE =
  'app/UserList/DELETE_USER_FROM_TEAM_FAILURE';

export const SET_USERS_ITEMS_STATE = 'app/UserList/SET_USERS_ITEMS_STATE';
